import logo from "../images/logo.png";
import { Toaster, toast } from "react-hot-toast";

import "animate.css";
import { useState } from "react";
import dataProvider from "./DataProvider";

const FirstLogin = props => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async e => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      await dataProvider.network.post("update-password", { password });
      toast.success("Password updated successfully");
      props.onUpdate();
    } catch (error) {
      console.error(error);
      toast.error("Failed to update password");
    }
  };

  return (
    <div id="login">
      <section className="white">
        <div className="logo">
          <img src={logo} alt="SpotTrek" />
        </div>
        <div className="form-wrapper">
          <form onSubmit={handleSubmit}>
            <h2>Reset Password!</h2>
            <p>Please set a new password</p>
            <div className="row">
              <label>Password</label>
              <input
                value={password}
                onChange={e => setPassword(e.target.value)}
                type="password"
                placeholder="New password"
                autoComplete="current-password"
              />
            </div>
            <div className="row">
              <label>Confirm Password</label>
              <input
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                type="password"
                placeholder="Confirm new password"
                autoComplete="confirm-password"
              />
            </div>
            <div className="row">
              <button>Update</button>
            </div>
          </form>
        </div>
        <p className="copy">&copy; BARC India 2024</p>
      </section>
      <Toaster />
    </div>
  );
};

export default FirstLogin;
